(() => {
  document.documentElement.classList.add('js');

  /* Header: solid background once the page scrolls */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile menu */
  const drawer = document.querySelector('[data-drawer]');
  const openBtn = document.querySelector('[data-menu-open]');
  if (drawer && openBtn) {
    const closeBtn = drawer.querySelector('[data-menu-close]');
    const open = () => {
      drawer.hidden = false;
      drawer.classList.add('is-open');
      document.body.classList.add('menu-open');
      openBtn.setAttribute('aria-expanded', 'true');
      closeBtn && closeBtn.focus();
    };
    const close = () => {
      drawer.hidden = true;
      drawer.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    };
    openBtn.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    drawer.querySelectorAll('[data-menu-link]').forEach((a) => a.addEventListener('click', () => { if (!drawer.hidden) close(); }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* Waitlist: Shopify marks every customer form as posted after a sign up.
     Keep the confirmation on the form that was actually submitted. */
  const hash = window.location.hash.replace('#', '');
  const posted = /customer_posted=true/.test(window.location.search);
  document.querySelectorAll('form[data-waitlist]').forEach((form) => {
    const root = form.querySelector('[data-wl-root]');
    if (!root || !root.classList.contains('is-success')) return;
    if (posted && hash && form.id !== hash) {
      root.classList.remove('is-success');
    } else if (form.id === hash) {
      const msg = root.querySelector('.wl__success');
      msg && msg.focus({ preventScroll: true });
    }
  });

  /* How to use: highlight the step in view */
  const steps = document.querySelectorAll('[data-step]');
  if (steps.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          steps.forEach((s) => s.classList.remove('is-active'));
          entry.target.classList.add('is-active');
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => io.observe(s));
    steps[0].classList.add('is-active');
  }

  /* Product gallery thumbnails */
  const stage = document.querySelector('[data-gallery]');
  if (stage) {
    const thumbs = document.querySelectorAll('[data-thumb]');
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const slide = document.getElementById(t.dataset.thumb);
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
    }));
    stage.addEventListener('scroll', () => {
      const i = Math.round(stage.scrollLeft / stage.clientWidth);
      thumbs.forEach((x, n) => x.classList.toggle('is-active', n === i));
    }, { passive: true });
  }

  /* Login page: reveal password recovery */
  document.querySelectorAll('[data-recover-toggle]').forEach((a) => a.addEventListener('click', () => {
    const el = document.getElementById('RecoverEmail');
    el && setTimeout(() => el.focus(), 50);
  }));
})();
